<div
  *ngIf="state as dialog"
  class="confirm-dialog-overlay"
  role="presentation"
>
  <div
    class="confirm-dialog"
    [class.confirm-dialog--danger]="dialog.variant === 'danger'"
    [class.confirm-dialog--warning]="dialog.variant === 'warning'"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="'confirmDialogTitle'"
  >
    <div class="confirm-dialog__body">
      <h3 id="confirmDialogTitle" class="confirm-dialog__title">{{ dialog.title }}</h3>
      <p class="confirm-dialog__message">{{ dialog.message }}</p>
      <ul *ngIf="dialog.details.length > 0" class="confirm-dialog__details">
        <li *ngFor="let detail of dialog.details">{{ detail }}</li>
      </ul>
    </div>

    <div class="confirm-dialog__actions">
      <button type="button" class="confirm-dialog__btn confirm-dialog__btn--cancel" (click)="onCancel()">
        {{ dialog.cancelLabel }}
      </button>
      <button
        type="button"
        class="confirm-dialog__btn confirm-dialog__btn--confirm"
        [class.confirm-dialog__btn--danger]="dialog.variant === 'danger'"
        [class.confirm-dialog__btn--warning]="dialog.variant === 'warning'"
        (click)="onConfirm()"
      >
        {{ dialog.confirmLabel }}
      </button>
    </div>
  </div>
</div>
